/** DatasetDependencySubType.kt */
const DATASET_DEPENDENCY_SUB_TYPE = {
	FIELD_EQUATION: 'field-equation',
		VISIBLE_LINKED_FIELD: 'visible-linked-field',
		DATASET_AGGREGATIONS_FIELD_ID: 'dataset-aggregations-field-id',
		SERIES_VLF: 'series-vlf',
		SHAPE_WIDGET: 'shape-widget',
		FILTER_WIDGET: 'filter-widget',
		TABLE_WIDGET: 'table-widget',
		TABLE_WIDGET_COLUMN: 'table-widget-column',
		TABLE_WIDGET_COLUMN_EQUATION: 'table-widget-column-equation',
		VALUE_WIDGET: 'value-widget',
		DASHBOARD_CHART: 'dashboard-chart',
		REPORT_CHART: 'report-chart',
		SCORECARD_CHART: 'scorecard-chart',
		AGGREGATION_VLF_ID: 'aggregation-vlf-id',
		DEFAULT_CALENDAR_VLF_ID: 'default-calendar-vlf-id',
		SELECTED_CALENDAR_VLF_ID: 'selected-calendar-vlf-id',
		DATASET_AGGREGATION: 'dataset-aggregation',
		TABLE_VLF_ID: 'table-vlf-id',
		ROW_BREAKDOWN_VLF_ID: 'row-breakdown-vlf-id',
		COLUMN_BREAKDOWN_VLF_ID: 'column-breakdown-vlf-id',
		FILTER_VLF_ID: 'filter-vlf-id',
		ANOTHER_TREE_VLF_ID: 'another-tree-vlf-id',
		MULTI_TIME_SERIES_CHART_AGGREGATION_VLF_ID: 'multi-time-series-chart-aggregation-vlf-id',
		MULTI_TIME_SERIES_CHART_DATE_VLF_ID: 'multi-time-series-chart-date-vlf-id',
		PERMISSIONS_FILTER: 'permissions-filter',
		REPORT_VISIBLE_LINKED_FIELD: 'report-visible-linked-field',
		REPORT_COLUMN_FIELD: 'report-column-field',
		REPORT_COLUMN_EQUATION_FIELD: 'report-column-equation-field',
		DASHBOARD_ONLY_DATASET_REPORT_DESIGNER: 'dashboard-only-dataset-report-designer',
		METRIC: 'metric',
		RECORD_LIST_WIDGET_COLUMN: 'record-list-widget-column',
		FORM_WIDGET: 'form-widget',
		CALCULATED_FIELD: 'calculated-field'
}

export default DATASET_DEPENDENCY_SUB_TYPE
DATASET_DEPENDENCY_SUB_TYPE.__filename__ = 'components/dataset-dependency-sub-type.js'
